import axios from 'axios'
import { BUSCAR_PONTOS_EMBARQUE_FILTRADO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions'
import { montarURLFiltro } from '../../util/filtros'

export default function buscarPontosEmbarqueFiltrado (idEmpresa, pagina, registrosPorPagina, filtros) {
  const urlFiltros = montarURLFiltro(filtros, pagina, registrosPorPagina)
  const url = `${URL}/ponto-embarque/empresa/${idEmpresa}/filtrar${urlFiltros}`

  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
    response => dispatch({ type: BUSCAR_PONTOS_EMBARQUE_FILTRADO, payload: response })
  )
}
